import { ErrorHandler, Injectable } from '@angular/core';

import { AuthService } from '../../services/http/auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class CustomErrorHandler implements ErrorHandler {
  constructor(private authService: AuthService) {}

  handleError(error: any): void {
    if (error && error?.statusCode === 200) {
      this.authService.logout();
    }
  }
}
